import { Technical } from "@/components/Marketing";

export default function Technique() {
  return <Technical />;
}
